<div class="font-poppins relative flex flex-col items-center gap-6 pt-0 px-6 pb-[70px]">
  <button
    type="button"
    class="flex justify-center items-center absolute right-[8px] top-[-16px] z-10 h-10 w-10 rounded-full bg-white text-neutral-gray-900 shadow-[0_2px_10px_rgba(0,56,139,0.12),0_0_4px_rgba(169,188,217,0.05)] transition-colors hover:bg-neutral-gray-200"
    (click)="closeRegisterModal()"
    aria-label="Cerrar"
  >
    <app-svg-icon [iconName]="SvgIcon.CLOSE_MODAL" [size]="20" />
  </button>

  <img src="assets/icons/new-logo-cantera.svg" alt="Cantera UNACEM" class="h-[120px] w-[150px] object-contain" />

  <div class="w-full text-center">
    <h2 class="font-poppins text-[20px] font-semibold leading-6 text-neutral-gray-900">
      Regístrate para continuar
    </h2>
    <p class="mx-auto mt-4 max-w-[312px] text-[14px] font-normal leading-[1.5] text-neutral-gray-700">
      Accede a todas las herramientas registrándote gratis o iniciando sesión
    </p>
  </div>

  <div class="w-full flex flex-col gap-2">
    <button
      type="button"
      class="h-14 w-full rounded-lg bg-cantera-red-primary font-poppins text-[16px] font-bold text-white transition-colors hover:brightness-95"
      (click)="goToRegisterUser()"
    >
      Registrarme gratis
    </button>

    <button
      type="button"
      class="h-14 w-full rounded-lg border-2 border-neutral-gray-900 bg-transparent font-poppins text-[16px] font-bold text-neutral-gray-900 transition-colors hover:bg-neutral-gray-100"
      (click)="goToLogin()"
    >
      Iniciar sesión
    </button>
  </div>
</div>